module.exports = __webpack_public_path__ + "media/images/photo/Residential/slider2-89b06ec76642006132461996d17a5191.svg";